// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import React, { useState, useEffect } from 'react';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import * as styles from '../styles/OpenAiWidget.styles';

const InlineConnector = (props: any): JSX.Element => (
  <StepConnector
    {...props}
    sx={{
      [`&.${stepConnectorClasses.alternativeLabel}`]: {
        top: 10,
        left: 'calc(-50% + 10px)',
        right: 'calc(-50% + 16px)'
      },
      [`& .${stepConnectorClasses.line}`]: {
        width: '100px',
        height: 1,
        border: '0.5px solid #00000033',
        borderRadius: 1
      }
    }}
  />
);

const CustomStepIcon: React.FC<{ active?: boolean; completed?: boolean }> = ({ active, completed }) => (
  <div style={styles.stepIconStyle(active, completed)} />
);

const InterviewStepper = (): JSX.Element => {
  const [step, setStep] = useState<number>(1);

  useEffect(() => {
    if (step >= 5) return;

    const timer = setInterval(() => {
      setStep((prev) => prev + 1);
    }, 240000); // 5 mins

    return () => clearInterval(timer);
  }, [step]);

  return (
    <div style={styles.interviewStepperContainerStyle}>
      <div style={styles.stepperWrapperStyle}>
        <Stepper activeStep={step - 1} alternativeLabel connector={<InlineConnector />} sx={{ width: '100%' }}>
          {Array.from({ length: 5 }, (_, i) => (
            <Step key={i} completed={step > i + 1}>
              <StepLabel
                StepIconComponent={() => <CustomStepIcon active={step === i + 1} completed={step > i + 1} />}
              />
            </Step>
          ))}
        </Stepper>
      </div>
    </div>
  );
};

export default InterviewStepper;
